<div class="add-card">
    <div class="container">
        <div class="row">
            <div class="col-10"></div>
            <div class="col-2 text-right">
                <span class="">
                    <img src="assets/icon/clear.svg" class="close" alt="close" (click)="closeDialog();crossBtnGA()">
                </span>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-10">
                <h2>Would you like to add a new card?</h2>
            </div>
            <div class="col-12 mt-4">
                <div class="strip bg-img" (click)="physicalCard();addCardClickGA('physical_card')" [routerLink]="['/pay/add-card-physical']">
                    <div class="icon">
                        <span class="img">
                            <img src="assets/icon/credit_card.svg" alt="user">
                        </span>
                     </div>
                     <div class="text mt-1">
                        <h6>
                            ALREADY HAVE A STARBUCKS CARD
                        </h6>
                        <p>
                            Enter the card number and security code to proceed. Save it with a unique name to keep it handy.
                        </p>
                     </div>
                </div>
                <hr>
                <div class="strip bg-img" (click) = "digitalCard();addCardClickGA('digital_card')" [routerLink]="['/pay/addcard']">
                     <div class="icon">
                        <span class="img">
                            <img src="assets/icon/add_circle.svg" alt="user">
                        </span>
                     </div>
                     <div class="text mt-1">
                        <h6>
                            BUY A NEW DIGITAL STARBUCKS CARD
                        </h6>
                        <p>
                            Choose from the existing card options and load it with minimum Rs 200. </p>
                     </div>
                </div>
            </div>
        </div>
    </div>
</div>